export default __webpack_public_path__ + "static/media/grid_music.a35f252b.svg";